import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectAllQR = ({ QRList_reducer }) => {
    return QRList_reducer.allQR;
};

export const getAllEquipmentTypes = ({ QRList_reducer }) => {
    return QRList_reducer.allEquipment;
};
export const selectCategories = ({ QRList_reducer }) => {
    return QRList_reducer.category;
};
export const getRequesting = ({ QRList_reducer }) => {
    return QRList_reducer.requesting;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectEquipmentType = ({ QRList_reducer }) => {
    return QRList_reducer.equType;
};
export const selectEquFilter = ({ QRList_reducer }) => {
    return QRList_reducer.equFilter;
};
export const selectDepartments = createSelector(
    [selectProfile],
    ({ departments = false }) => {
        if (departments) return departments;
        else return null;
    }
);
export const selectAreas = createSelector(
    [selectProfile],
    ({ areas = false }) => {
        if (areas) return areas;
        else return null;
    }
);
export const selectCategoryTitles = createSelector([selectCategories], categories => {
    let titleArr = []
    if (
        categories === false ||
        typeof categories === "undefined" ||
        categories === null
    ) {
        return [];
    }

    Object.values(categories).map(e => {
        titleArr.push(e)
        return null;
    });
    return titleArr;
});
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["equipment_manager"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectAllEquipmentTypes = createSelector(
    [getAllEquipmentTypes],
    (allEquipment) => {
        if (
            allEquipment === false ||
            typeof allEquipment === "undefined" ||
            allEquipment === null
        ) {
            return [];
        }
        let equipmentTypes = _.compact(Object.values(allEquipment));
        return equipmentTypes;
    }
);

export const selectQR = createSelector(
    [selectAllQR, selectProfile, selectEquipmentType, selectEquFilter],
    (
        qrs = false,
        { departments = false, areas = false },
        equType = false,
        equFilter = false
    ) => {
        if (qrs) {
            let qrInfo = _.compact(
                Object.keys(qrs).map((qr_uid) => {
                    let created_by =
                        _.get(qrs[qr_uid], "profile.created_by") || "";

                    let description =
                        _.get(qrs[qr_uid], "profile.description") || "";
                    let name = _.get(qrs[qr_uid], "profile.name") || "";
                    let photo_url =
                        _.get(qrs[qr_uid], "profile.photo_url") || "";
                    let qr_code_url =
                        _.get(qrs[qr_uid], "profile.qr_code_url") || "";
                    let status = _.get(qrs[qr_uid], "profile.status") || "";
                    let service_period =
                        _.get(qrs[qr_uid], "profile.service_period") || "";
                    let uid = _.get(qrs[qr_uid], "profile.uid") || "";
                    let category = _.get(qrs[qr_uid], "profile.category") || "";
                    let date_last_examination =
                        _.get(qrs[qr_uid], "profile.date_last_examination") ||
                        "";
                    let date_last_service =
                        _.get(qrs[qr_uid], "profile.date_last_service") || "";
                    let thorough_examination_period =
                        _.get(
                            qrs[qr_uid],
                            "profile.thorough_examination_period"
                        ) || "";
                    let location_lat =
                        _.get(qrs[qr_uid], "profile.location_lat") || "";
                    let location_lon =
                        _.get(qrs[qr_uid], "profile.location_lon") || "";
                    let area = _.get(qrs[qr_uid], "profile.area") || null;
                    let department =
                        _.get(qrs[qr_uid], "profile.department") || null;
                    let attached_files =
                        _.get(qrs[qr_uid], "profile.attached_files") || [];
                    let timestamp =
                        _.get(qrs[qr_uid], "profile.timestamp") || null;
                    let utc_timestamp = new Date(timestamp);
                    let refdate = moment(timestamp, "DD-MM-YYYY HH:mm:ss");
                    utc_timestamp = parseInt(
                        (new Date(refdate).getTime() / 1000).toFixed(0)
                    );
                    let file_id = _.get(qrs[qr_uid], "profile.uid") || "";
                    let history = _.get(qrs[qr_uid], "history") || null;
                    let notes = _.get(qrs[qr_uid], "profile.notes") || "";
                    let inspection_due_date =
                        _.get(qrs[qr_uid], "profile.inspection_due_date") || "";
                    return {
                        created_by,
                        description,
                        name,
                        photo_url,
                        notes,
                        qr_code_url,
                        status,
                        attached_files,
                        service_period,
                        category,
                        date_last_examination,
                        date_last_service,
                        thorough_examination_period,
                        location_lat,
                        area,
                        department,
                        location_lon,
                        uid,
                        timestamp,
                        utc_timestamp,
                        file_id,
                        inspection_due_date,
                        history,
                    };
                })
            );
            if (departments) {
                qrInfo = qrInfo.filter((e) => {
                    if (e.department) {
                        let flag = false;
                        e.department.map((qrd) => {
                            departments.map((f) => {
                                if (f === qrd) {
                                    flag = true;
                                }
                                return null;
                            });
                            return null;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }

            if (areas) {
                qrInfo = qrInfo.filter((e) => {
                    if (e.area) {
                        let flag = false;
                        e.area.map((qrd) => {
                            areas.map((f) => {
                                if (f === qrd) {
                                    flag = true;
                                }
                                return null;
                            });
                            return null;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }

            if (equType !== "all_categories") {
                qrInfo = qrInfo.filter((e) => {
                    return e.category === equType;
                });
            }
            if (equFilter) {
                qrInfo = qrInfo.filter((e) => {
                    return e.name
                        .toLowerCase()
                        .includes(equFilter.toLowerCase());
                });
            }
            return _.orderBy(qrInfo, "description");
        } else {
            return false;
        }
    }
);

export const expirySelectQR = createSelector(
    [selectAllQR, selectProfile, selectEquipmentType],
    (qrs = false, { departments = false, areas = false }, equType = false) => {
        if (qrs) {
            let qrInfo = _.compact(
                Object.keys(qrs).map((qr_uid) => {
                    let created_by =
                        _.get(qrs[qr_uid], "profile.created_by") || "";

                    let description =
                        _.get(qrs[qr_uid], "profile.description") || "";
                    let name = _.get(qrs[qr_uid], "profile.name") || "";
                    let photo_url =
                        _.get(qrs[qr_uid], "profile.photo_url") || "";
                    let qr_code_url =
                        _.get(qrs[qr_uid], "profile.qr_code_url") || "";
                    let status = _.get(qrs[qr_uid], "profile.status") || "";
                    let service_period =
                        _.get(qrs[qr_uid], "profile.service_period") || "";

                    let category = _.get(qrs[qr_uid], "profile.category") || "";
                    let date_last_examination =
                        _.get(qrs[qr_uid], "profile.date_last_examination") ||
                        "";
                    let date_last_service =
                        _.get(qrs[qr_uid], "profile.date_last_service") || "";
                    let thorough_examination_period =
                        _.get(
                            qrs[qr_uid],
                            "profile.thorough_examination_period"
                        ) || "";
                    let location_lat =
                        _.get(qrs[qr_uid], "profile.location_lat") || "";
                    let location_lon =
                        _.get(qrs[qr_uid], "profile.location_lon") || "";
                    let area = _.get(qrs[qr_uid], "profile.area") || null;
                    let department =
                        _.get(qrs[qr_uid], "profile.department") || null;
                    let attached_files =
                        _.get(qrs[qr_uid], "profile.attached_files") || [];
                    let timestamp =
                        _.get(qrs[qr_uid], "profile.timestamp") || null;
                    let history = _.get(qrs[qr_uid], "history") || "";
                    let notes = _.get(qrs[qr_uid], "profile.notes") || "";
                    let expDate = moment(date_last_service, "DD/MM/YYYY");
                    let currentDate = moment();
                    let days = currentDate.diff(expDate, "days");
                    if (days > 90) {
                        return {
                            uid: qr_uid,

                            created_by,
                            description,
                            name,
                            photo_url,
                            notes,
                            qr_code_url,
                            status,
                            attached_files,
                            service_period,
                            category,
                            date_last_examination,
                            date_last_service,
                            thorough_examination_period,
                            location_lat,
                            area,
                            department,
                            location_lon,

                            timestamp,

                            history,
                        };
                    } else return null;
                })
            );
            if (departments) {
                qrInfo = qrInfo.filter((e) => {
                    if (e.department) {
                        let flag = false;
                        e.department.map((qrd) => {
                            departments.map((f) => {
                                if (f === qrd) {
                                    flag = true;
                                }
                                return null;
                            });
                            return null;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }

            if (areas) {
                qrInfo = qrInfo.filter((e) => {
                    if (e.area) {
                        let flag = false;
                        e.area.map((qrd) => {
                            areas.map((f) => {
                                if (f === qrd) {
                                    flag = true;
                                }
                                return null;
                            });
                            return null;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }

            if (equType !== "all_categories") {
                qrInfo = qrInfo.filter((e) => {
                    return e.category === equType;
                });
            }
            return _.orderBy(qrInfo, "description");
        } else {
            return false;
        }
    }
);
